import React from 'react';
import Header from './Header';
import { useMsal } from '@azure/msal-react';
import useBotPagesConfig from '../../hooks/useBotPagesConfig.ts';

const SignIn: React.FC = () => {
    const { clientId } = useBotPagesConfig();
    const { instance } = useMsal();

    const login = () => {
        const loginRequest = {
            scopes: [`${clientId}/.default`],
            prompt: 'select_account',
            state: window.location.host.split('.')[0] // Get sub domain from domain. i.e. "sub" from sub.dev.com
        };

        instance
            .loginPopup(loginRequest)
            .then(() => {
                // Here you can extract the token if needed
                // const token = response.idToken;
            })
            .catch((error) => {
                console.error(error);
            });
    };

    return (
        <>
            <Header hideSearch>
                <div
                    id='SignInNotice'
                    className='alert alert-info markdown-strip-margin hero-message'
                >
                    This page is protected and you need to sign in before
                    viewing
                </div>
                <div>
                    <button
                        type='button'
                        id='SignInButton'
                        className='btn btn-primary'
                        onClick={login}
                    >
                        Sign in
                    </button>
                </div>
            </Header>
        </>
    );
};

export default SignIn;
